export default __webpack_public_path__ + "static/media/directorsdesk.1aab22ef.jpg";